<div class="filters" role="group" aria-label="Analytics filters">
  <label class="pill">
    <span class="pill-label">Range</span>
    <select
      [ngModel]="filter().dateRange"
      (ngModelChange)="onRange($event)"
      aria-label="Date range"
    >
      <option value="week">This week</option>
      <option value="month">This month</option>
      <option value="year">This year</option>
      <option value="all">All time</option>
      <option value="custom">Custom</option>
    </select>
  </label>

  @if (filter().dateRange === 'custom') {
    <label class="pill">
      <span class="pill-label">From</span>
      <app-date-input
        variant="bare"
        ariaLabel="From date"
        [ngModel]="formatDate(filter().start)"
        (ngModelChange)="onCustomDate('start', $event)"
      />
    </label>
    <label class="pill">
      <span class="pill-label">To</span>
      <app-date-input
        variant="bare"
        ariaLabel="To date"
        [ngModel]="formatDate(filter().end)"
        (ngModelChange)="onCustomDate('end', $event)"
      />
    </label>
  }

  <label class="pill">
    <span class="pill-label">Status</span>
    <select
      [ngModel]="filter().status"
      (ngModelChange)="onStatus($event)"
      aria-label="Status"
    >
      <option value="all">All</option>
      <option value="approved">Approved</option>
      <option value="pending">Pending</option>
    </select>
  </label>

  @if (showProject()) {
    <label class="pill project-filter">
      <span class="pill-label">Projects</span>
      <app-project-dropdown
        [projects]="projects()"
        [selectedProject]="selectedProject()"
        [allowNull]="true"
        [nullOptionLabel]="'All projects'"
        [compact]="true"
        [embedded]="true"
        (projectSelected)="onProject($event)"
      />
    </label>
  }
  @if (showUser()) {
    <label class="pill">
      <span class="pill-label">Team member</span>
      <select
        [ngModel]="filter().userId ?? ''"
        (ngModelChange)="onUser($event)"
        aria-label="Team member"
      >
        <option value="">Everyone</option>
        @for (user of users(); track user.id) {
          <option [value]="user.id">{{ displayName(user) }}</option>
        }
      </select>
    </label>
  }

  @if (showCategory()) {
    <label class="pill">
      <span class="pill-label">Category</span>
      <select
        [ngModel]="filter().category ?? ''"
        (ngModelChange)="onCategory($event)"
        aria-label="Category"
      >
        <option value="">All</option>
        @for (category of categories(); track category) {
          <option [value]="category">{{ category }}</option>
        }
      </select>
    </label>
  }
</div>
